/**
 * Created by calhosh on 7/16/2017.
 */
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import _ from 'lodash';
import Utility from '../../../util/utilityfunctions';
import {setFormV2ToasterVisibility} from '../../../actions/Toast/toastactions';
import ToastMessageContainer from '../Toast/ToastMessageContainer';
import ErrorsUtility from '../Errors/index';

export default function ModalErrors({modalLevel}) {
	const errors = useSelector((store) => store.errors),
		isModalOpen = useSelector((store) => store.isModalOpen),
		isADCModalOpen = useSelector((store) => store.isADCModalOpen),
		currentModalLevel = useSelector((store) => store.modalLevel);

	const dispatch = useDispatch();

	const showErrors = isModalOpen && !isADCModalOpen && currentModalLevel === modalLevel;

	const addNotification = (level, message, autoDismissInSeconds) => {
		isModalOpen &&
			dispatch(
				setFormV2ToasterVisibility(true, level, Utility.createRichTextElement(message), '', autoDismissInSeconds)
			);
	};

	useEffect(() => {
		ErrorsUtility.addNotification(errors, addNotification);
	}, [errors]);

	return (
		<>{showErrors && <ToastMessageContainer toastClassName={'modalErrors'} className="modal-messages-container" />}</>
	);
}
